<div class="auth-content">
  <h2>Who are you?</h2>

  <div
    class="entity-card"
    [class.selected]="selection() === 'facility'"
    (click)="onSelectionChange('facility')"
    (keydown.enter)="onSelectionChange('facility')"
    tabindex="0"
    role="button"
  >
    <umss-icon
      [name]="'phosphorBuildings'"
      [color]="'var(--neutral-800)'"
      [size]="'30px'"
    ></umss-icon>
    <div>
      <p class="pg-medium">Facility</p>
      <p class="pg-mini-medium">One facility with one name</p>
    </div>
  </div>

  <div
    class="entity-card"
    [class.selected]="selection() === 'corporation'"
    (click)="onSelectionChange('corporation')"
    (keydown.enter)="onSelectionChange('corporation')"
    tabindex="0"
    role="button"
  >
    <umss-icon
      [name]="'phosphorCity'"
      [color]="'var(--neutral-800)'"
      [size]="'30px'"
    ></umss-icon>
    <div>
      <p class="pg-medium">Corporation</p>
      <p class="pg-mini-medium">A company who owns many facilities</p>
    </div>
  </div>

  <div class="social-buttons">
    <umss-button
      [variant]="'Primary'"
      [size]="'Regular'"
      [label]="'Get started'"
      (onClick)="onGetStarted()"
      [fullWidth]="true"
      [disabled]="selection() === undefined"
    >
    </umss-button>
  </div>
  <div class="already-have-an-container">
    <span class="already-have-an">Already have an account? </span>
    <a class="sign-in" [routerLink]="'/auth/login'">Sign in</a>
  </div>
</div>
